import { FC } from "react";
import { ViewOptions } from "../types";
import "./ViewType.css";

interface ViewTypeProps {
	view: ViewOptions;
	setView: (view: ViewOptions) => void;
}

const ViewType: FC<ViewTypeProps> = ({ setView, view }) => {
	return (
		<div className="scb-view-type">
			<input
				type="radio"
				id="monthlyView"
				value={ViewOptions.MONTHLY}
				checked={view === ViewOptions.MONTHLY}
				onChange={() => setView(ViewOptions.MONTHLY)}
			/>
			<label
				htmlFor="monthlyView"
				className={`elementor-button radio-label ${
					view === ViewOptions.MONTHLY ? "active" : ""
				}`}
			>
				<span className="scb-desktop">Kalenderansicht</span>
				<span className="scb-mobile">Kalender</span>
			</label>
			<input
				type="radio"
				id="listView"
				value={ViewOptions.LIST}
				checked={view === ViewOptions.LIST}
				onChange={() => setView(ViewOptions.LIST)}
			/>
			<label
				htmlFor="listView"
				className={`elementor-button radio-label ${
					view === ViewOptions.LIST ? "active" : ""
				}`}
			>
				<span className="scb-desktop"> Listenansicht</span>
				<span className="scb-mobile"> Liste</span>
			</label>

			{/* <input
				type="radio"
				id="weeklyView"
				value={ViewOptions.WEEKLY}
				checked={view === ViewOptions.WEEKLY}
				onChange={() => setView(ViewOptions.WEEKLY)}
			/>
			<label
				htmlFor="weeklyView"
				className={`radio-label ${view === ViewOptions.WEEKLY ? "active" : ""}`}
			>
				Wochentliche Ansicht
			</label> */}
		</div>
	);
};

export default ViewType;
